import { render } from "./CustomOptionContent.vue?vue&type=template&id=405cff1a"
import script from "./CustomOptionContent.vue?vue&type=script&lang=js"
export * from "./CustomOptionContent.vue?vue&type=script&lang=js"
script.render = render

export default script